
// window._ = require('lodash');

if (!Array.prototype.flat) {
    Array.prototype.flat = function (depth) {
        depth = typeof depth === 'undefined' ? 1 : Math.floor(depth);
        if (depth < 1) return Array.prototype.slice.call(this);
        return Array.prototype.reduce.call(this, function (acc, val) {
            if (Array.isArray(val) && depth > 0) {
                return acc.concat(Array.prototype.flat.call(val, depth - 1));
            }
            return acc.concat(val);
        }, []);
    };
}

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

window.$ = window.jQuery = require('jquery');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
let token;

if ('Laravel' in window && 'csrfToken' in window.Laravel) {
    token = window.Laravel.csrfToken;
}

if (! token && document.head.querySelector('meta[name="csrf-token"]')) {
    token = document.head.querySelector('meta[name="csrf-token"]').content;
}

window.axios = require('axios');
window.axios.defaults.withCredentials = true;
window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: 'your-pusher-key'
// });
